<template>
  <div style="margin: 0 auto; max-width: 700px;">
    <div class="mt-3 ml-3 mr-3">
      <h1 style="text-align: center;">FAQs</h1>
      <div style="height: 2px; width: 100%;background-color: black;" class="mb-3"></div>

      <div>
        <h3
          style="font-weight: 700; margin-top: 15px; margin-bottom: 10px;"
        >Is shipping really free?!</h3>
        <p
          style="margin-left: 20px; margin-right: 10px;"
        >Yes! We don't nickel and dime you and we don't throw in a bunch of hidden fees. All orders have free shipping!</p>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-3"></div>

        <h3
          style="font-weight: 700; margin-top: 15px; margin-bottom: 10px;"
        >When will I get my stickers?</h3>
        <p
          style="margin-left: 20px; margin-right: 10px;"
        >All stickers are printed in 1 business day and take 2-5 business days for shipping.</p>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-3"></div>

        <h3
          style="font-weight: 700; margin-top: 15px; margin-bottom: 10px;"
        >What is the quality of the stickers?</h3>
        <p
          style="margin-left: 20px; margin-right: 10px;"
        >We use quality sticker paper so that your prints look sharp and vibrant.</p>

        <p
          style="margin-left: 20px; margin-right: 10px;"
        >Our stickers are water resistant, but are not completely waterproof. Prolonged exposure to water can lead to damage.</p>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-3"></div>

        <h3
          style="font-weight: 700; margin-top: 15px; margin-bottom: 10px;"
        >What if there is an issue with my order?</h3>
        <p style="margin-left: 20px; margin-right: 10px;">
          If you receive your order and it was damaged while shipping or if there is any other issue, use the form below to message
          us and we will get back to you shortly.
        </p>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-3"></div>

        <h3
          style="font-weight: 700; margin-top: 15px; margin-bottom: 10px;"
        >Why don't you ship internationally?</h3>
        <p style="margin-left: 20px; margin-right: 10px;">
          We strive to give the customer a fantastic experience and we currently can not provide the quality and service that we
          would like to for international customers.
        </p>

        <div style="height: 1px; width: 100%;background-color: black;" class="mb-10"></div>
      </div>
    </div>
    <div class="ml-5 mr-5 mb-5" v-bind:class="{ errorShake: isErrorShake }">
      <div
        class="mt-5 ml-5 mr-5 mb-5"
        style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto !important; box-shadow: 0 0 10px rgb(150, 150, 150)"
      >
        <div style="text-align: center; margin: 0 auto;">
          <h2 class="mb-4">Contact Us</h2>
        </div>

        <div v-if="this.error != ''">
          <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
        </div>

        <div v-if="this.message != ''">
          <v-alert type="success" v-bind="this.message" style="font-weight: bold;">{{this.message}}</v-alert>
        </div>

        <v-form ref="form">
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-text-field
              background-color="white"
              color="success"
              height="40"
              label="Your Email"
              required
              :rules="[rules.required]"
              v-model="email"
              type="email"
            ></v-text-field>
          </div>
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-textarea
              background-color="white"
              color="success"
              label="Message"
              required
              :rules="[rules.required]"
              v-model="userMessage"
              type="message"
            ></v-textarea>
          </div>
          <div style="width: 60%; margin: 0 auto;">
            <v-btn
              class="mb-2"
              style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
              height="50"
              color="success"
              @click="sendEmail"
            >Send Email</v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data: () => ({
    error: "",
    isErrorShake: false,
    email: "",
    message: "",
    userMessage: "",
    rules: {
      required: value => !!value || "Required."
    }
  }),
  mounted() {
    this.scrollToTop();
    if (this.$store.state.user != undefined) {
      this.email = this.$store.state.user.email;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async sendEmail() {
      if (this.email == "" || this.userMessage == "") {
        this.error = "Please fill in both fields";
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      } else {
        this.error = "";
        try {
          const response = await UserService.email({
            email: this.email,
            userMessage: this.userMessage
          });
          this.message = response.data.message;
        } catch (error) {
          this.error = error.response.data.error;
          this.isErrorShake = true;
          setTimeout(() => {
            this.isErrorShake = false;
          }, 800);
        }
      }
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.errorShake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.75s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
